module.exports = __webpack_public_path__ + "react-public-static/media/eames.59358179.png";